export interface EntityBase { id: number }
export interface EntityInfo extends EntityBase { name: string }

export type EnumBase<T> = { [P in keyof T]: number };
export interface EnumInfo<T extends EnumBase<T>> { value: T; name: string }
